import { HelmetDexteel } from "@dexteel/mesf-core";
import { Box, Typography } from "@mui/material";

import { useAssetId } from "@/setup/hooks/useAssetId";
import { DEFAULT_MILL, type MillId } from "@/setup/mill-config/mill-config";
import { TestShackWorkspace } from "./components/TestShackWorkspace";

export const TestShackPage = () => {
	const assetId = (useAssetId() as MillId) ?? DEFAULT_MILL.id;
	return <TestShackPageContent key={assetId} assetId={assetId} />;
};

const TestShackPageContent = ({ assetId }: { assetId: MillId }) => {
	return (
		<>
			<HelmetDexteel title="Section Profile - Test Shack" />
			<Box
				data-test-id="test-shack-page"
				sx={{
					height: "calc(100vh - 64px)",
					boxSizing: "border-box",
					px: 2,
					py: 2,
					display: "grid",
					gridTemplateRows: "auto minmax(0, 1fr)",
					gap: 1,
				}}
			>
				<Box
					sx={{ display: "flex", alignItems: "center", gap: 2, flexShrink: 0 }}
				>
					<Typography variant="h5" fontWeight={600}>
						Section Profile - Test Shack
					</Typography>
				</Box>
				<TestShackWorkspace assetId={assetId} />
			</Box>
		</>
	);
};
